import React from 'react';
import { BoxIcon } from 'lucide-react';
interface EmptyStateProps {
  icon: typeof BoxIcon;
  title: string;
  description: string;
  action?: React.ReactNode;
  className?: string;
}
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className = ''
}: EmptyStateProps) {
  return <div className={`flex flex-col items-center justify-center p-16 text-center bg-white border border-border rounded-lg shadow-sm ${className}`} data-id="element-1059">
      <div className="w-20 h-20 mb-6 rounded-2xl bg-surface-warm flex items-center justify-center relative" data-id="element-1060">
        <Icon className="w-9 h-9 text-text-tertiary" data-id="element-1061" />
        <div className="absolute inset-0 rounded-2xl bg-gradient-to-b from-transparent to-border/10" data-id="element-1062" />
      </div>
      <h3 className="text-lg font-bold text-text-primary mb-2" data-id="element-1063">{title}</h3>
      <p className="text-sm text-text-secondary max-w-sm mb-6 leading-relaxed" data-id="element-1064">
        {description}
      </p>
      {action && <div className="animate-fade-in" data-id="element-1065">{action}</div>}
    </div>;
}